import * as React from 'react'

const SvgForumIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.875 4.375H6.25A1.877 1.877 0 004.375 6.25v6.875A1.877 1.877 0 006.25 15H10v-1.25H6.25a.625.625 0 01-.625-.625V6.25c0-.345.28-.625.625-.625h10.625c.345 0 .625.28.625.625v6.875c0 .345-.28.625-.625.625h-3.25l-3 4.284 1.024.716L14.276 15h2.599a1.877 1.877 0 001.875-1.875V6.25a1.877 1.877 0 00-1.875-1.875zm-15 6.25H.625V2.5A1.877 1.877 0 012.5.625h8.125v1.25H2.5a.626.626 0 00-.625.625v8.125z"
      fill="#163250"
    />
  </svg>
)

export default SvgForumIcon
